import {
  FINISH_FETCH_INCENTIVE_COSTS_PROVIDERS,
  ADD_PROVIDER_TO_INCENTIVE_SUCCESS,
  REMOVE_PROVIDER_FROM_INCENTIVE_SUCCESS,
  START_FETCH_INCENTIVE_COSTS_PROVIDERS,
  START_TOGGLE_PROVIDER_IN_INCENTIVE
} from '../actions';

const initialState = {
  items:            [],
  page:             0,
  per_page:         10,
  total_entries:    0,
  errors:           undefined,
  loading:          false,
  addingProvider:   false,
  togglingProvider: false
};

const providersReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_FETCH_INCENTIVE_COSTS_PROVIDERS:
      return { ...state, loading: true };
    case FINISH_FETCH_INCENTIVE_COSTS_PROVIDERS: {
      const { response: { data } } = action;
      return { ...state, ...data, loading: false };
    }
    case ADD_PROVIDER_TO_INCENTIVE_SUCCESS: {
      let newProviders = [].concat(state.items);
      const idx = newProviders.findIndex( provider => provider.id === action.providerId );
      newProviders[idx] = {...state.items[idx], assigned: 'Y'}
      return { ...state, togglingProvider: false, items: newProviders };
    }
    case REMOVE_PROVIDER_FROM_INCENTIVE_SUCCESS:
      let newProviders = [].concat(state.items);
      const idx = newProviders.findIndex( provider => provider.id === action.providerId );
      newProviders[idx] = {...state.items[idx], assigned: 'N'}
      return { ...state, togglingProvider: false, items: newProviders };
    case START_TOGGLE_PROVIDER_IN_INCENTIVE:
      return { ...state, togglingProvider: true };
    default:
      return state;
  }
};

export default providersReducer;
